(function () {
  function switchTabsContent(data_content, name) {
    var $contents = $('.' + data_content);
    var $target = $('.' + data_content + '-' + name);

    if (!$target.length) {
      return;
    }

    var $current = $contents.filter('.active').not($target);
    if (!$current.length) {
      $current = $contents.filter(':visible').not($target);
    }

    $contents.stop(true, true).off('transitionend.productTabs');

    if ($target.hasClass('active') && !$current.length) {
      $target.css({ display: 'flex', opacity: 1 });
      return;
    }

    var showTarget = function () {
      $contents.not($target).removeClass('active').css({ display: 'none', opacity: 0 });
      $target.addClass('active').css({ display: 'flex', opacity: 0 });
      requestAnimationFrame(function () {
        $target.css('opacity', 1);
      });
    };

    if ($current.length) {
      var done = false;
      var finish = function () {
        if (done) {
          return;
        }
        done = true;
        $current.off('transitionend.productTabs');
        showTarget();
      };

      $current.css('opacity', 0).one('transitionend.productTabs', function (event) {
        if (event.originalEvent.propertyName == 'opacity') {
          finish();
        }
      });
      setTimeout(finish, 240);
    } else {
      showTarget();
    }
  }

  $('.product-tabs-box .product-tabs .product-tabs-tab').on('click', function () {
    var idx = $(this).index();
    var name = $(this).attr('data-name');
    var form_name = $(this).attr('data-form_name') || $(this).closest('.product-tabs').attr('data-form_name');
    var custom_class = $(this).attr('data-line-class');
    var data_content = $(this).attr('data-content');
    var max_length = $(this).attr('max-length');
    var setp = form_name == 'guide_tabs' ? 33.33 : 25;
    if (form_name == 'guide_tabs') {
      $('.product-tabs-box .guide_pupop_tabs .product-tabs-tab').not($(this)).removeClass('active');
      $(this).addClass('active');
      gsap.to('.product-tabs-box .guide_pupop_tabs', {
        duration: 1,
        scrollTo: {
          x: $(this),
          offsetX: 20
        },
        ease: "power2.out"
      });

    }
    // if(form_name == 'guide_tabs'){
    //     gsap.to()
    // }
    // console.log(idx)
    else if (form_name == 'product_tabs') {
      if ($('.' + data_content)) {
        var left_value = window.innerWidth > 1024 ? (idx == 0 ? '0%' : idx == 1 ? '25%' : idx == 2 ? '51.5%' : idx == 3 ? '80%' : idx == 4 ? '82%' : '0%') : (idx == 0 ? '0%' : idx == 1 ? '25%' : idx == 2 ? '52%' : idx == 3 ? '80%' : idx == 4 ? '80%' : '0%');
        gsap.to('.' + custom_class + ' .product-tabs-linebox-line', {
          left: left_value,
          duration: 0.5
        });
        switchTabsContent(data_content, name);
        if (name == 'guide') {
          $('.guide-pupop-box') ? $('.guide-pupop-box').fadeIn(300) : '';
          if (window.innerWidth < 1000) {
            document.body.classList.add("scroll-lock");
          }
          if (window.innerWidth >= 1000) {
            document.querySelectorAll('#main > div').forEach((el) => el.hidden = true);
            if (document.querySelector(".shopify-section-group-footer-group")) {
              document.querySelector(".shopify-section-group-footer-group").hidden = true;
            }
          }
        }
      }

    } else {
      if ($('.' + data_content)) {
        gsap.to('.' + custom_class + ' .product-tabs-linebox-line', {
          left: idx * setp + '%',
          duration: 0.5
        });
        switchTabsContent(data_content, name);
        if (name == 'guide' && $('.guide-pupop-box')) {
          if (window.innerWidth < 1000) {
            document.body.classList.add("scroll-lock");
          }
          if (window.innerWidth >= 1000) {
            document.querySelectorAll('#main > div').forEach((el) => el.hidden = true);
            if (document.querySelector(".shopify-section-group-footer-group")) {
              document.querySelector(".shopify-section-group-footer-group").hidden = true;
            }
          }
          $('.guide-pupop-box').fadeIn(300);
        }
      }

    }



  })
  $('.product-tabs-box .fabric_image').on('click', function () {
    var index = $(this).parent().index();
    console.log(index)
    $('.fabric_image_list_item_imgbox').hide();
    $('.fabric-pupop-desc-item').hide();
    $('.fabric_image_list_item_imgbox').eq(index).fadeIn(300);
    $('.fabric-pupop-desc-item').eq(index).fadeIn(300);
    $('.fabric-pupop .fabric-pupop-content').hide();
    $('.fabric-pupop-box').show();
    $('.fabric-pupop .fabric-pupop-content').fadeIn(300);

  })

  $('#select_size_button').on('click', function () {
    gsap.to('.add-to-card-pupop-content', {
      height: 'auto',
      duration: 0.5,
      ease: 'power2.inOut'
    });
    $('.add-to-card-pupop').addClass('active')
    gsap.to('.add-to-card-pupop-btn', {
      background: '#1F1F1F',
      duration: 0.5,
    })

  })

  $(document).on('pointerdown', '#add-to-card-sizebox .add-to-card-sizebox-item', function (event) {
    var $label = $(this).find('.add-to-card-sizebox-item-label');
    if ($label.hasClass('disabled')) {
      return;
    }
    $(this).closest('#add-to-card-sizebox').find('.add-to-card-sizebox-item-label').removeClass('active');
    $label.addClass('active');
    if (!$(event.target).closest('.add-to-card-sizebox-item-label').length && $label.get(0)) {
      $label.get(0).click();
    }
  })
  $('#add-to-card-pupop-btn-card').on('click', function () {
    if (!$(this).attr('disabled')) {
      $('.product buy-buttons button[type="submit"').click();
    }
  })

  $('.guide_pupop_top_cm_in_switch_item').on('click', function () {
    $(this).parent().parent().toggleClass('guide_pupop_content_show_cm');

  })

  $(document).ready(function () {
    $('#add-to-card-pupop-btn-card').text($('.product buy-buttons button[type="submit"] button-content').attr('up-text'));
    $('#add-to-card-pupop-btn-card').attr("disabled", $('.product buy-buttons button[type="submit"]').attr('disabled'))

    console.log(localStorage.getItem('notify_succsess'))
    if (localStorage.getItem('notify_succsess')) {
      $('.add-to-card-pupop').hide();
      $('.notify-me-pupopbox').show();
      localStorage.removeItem('notify_succsess');
    }

  });

})();

let currentUnit = 'cm';

const cellCache = new Map();
const textCache = new Map();

// 切换单位的函数
function toggleUnits() {
  const targetUnit = currentUnit === 'cm' ? 'in' : 'cm';

  const rows = document.querySelectorAll('.guide_pupop_content .size-table tr');

  // convert table
  rows.forEach((row, index) => {
    // skip header
    if (index === 0) return;

    const cells = row.querySelectorAll('td');
    cells.forEach((cell, i) => {
      // skip row header
      if (i > 0) {
        let text = cell.innerText.trim();

        if (text && text !== '/') {
          // save current value to cache
          if (!cellCache.has(`${currentUnit}-${index}-${i}`)) {
            cellCache.set(`${currentUnit}-${index}-${i}`, text);
          }
          if (cellCache.has(`${targetUnit}-${index}-${i}`)) {
            text = cellCache.get(`${targetUnit}-${index}-${i}`);
          } else {
            text = processCellValue(text);  // 处理带斜杠的数值和普通数值
          }
          cell.innerText = text;
        }
      }
    });
  });

  // 处理 class="guide_pupop_content-gui_pupop_tab1" 下的 p 元素
  const paragraphs = document.querySelectorAll('.guide_pupop_content-gui_pupop_tab1 p');
  paragraphs.forEach((p, i) => {
    let text = p.innerText;
    // save current value to cache
    if (!textCache.has(`${currentUnit}-${i}`)) {
      textCache.set(`${currentUnit}-${i}`, text);
    }
    if (textCache.has(`${targetUnit}-${i}`)) {
      text = textCache.get(`${targetUnit}-${i}`);
    } else {
      // 处理文本中的 cm 或 in 单位
      text = processTextUnits(text);
    }
    p.innerText = text; // 更新 p 元素的内容
  });

  // 切换单位
  currentUnit = currentUnit === 'cm' ? 'in' : 'cm';

  // console.log("当前单位:", currentUnit);  // 输出当前单位
}

// 处理带斜杠的数值或单独的数值
function processCellValue(value) {
  if (value.includes('/')) {
    // 处理带斜杠的数值
    const parts = value.split('/');
    if (parts.length === 2) {
      const numerator = parts[0].trim();
      const denominator = parts[1].trim();

      // 转换分子和分母
      const convertedNumerator = convertCellValue(numerator, currentUnit);
      // const convertedDenominator = convertUnit(denominator, currentUnit);

      return `${convertedNumerator}/${denominator}`;
    }
  } else {
    // 对单独的数值进行转换
    return convertCellValue(value, currentUnit);
  }
  return value; // 如果没有斜杠，返回原始值
}

// 处理文本中的数值，寻找 cm 或 in 并进行转换
function processTextUnits(text) {
  // 匹配所有带 cm 或 in 的数值，如 170cm, 5′7″, 56.3cm 等
  const regex = /(\d+(?:\.\d+)?\s*cm)|(\d+'\s*\d+(?:\.\d+)?")/gim;

  // 使用正则表达式替换文本中的数值
  const unitStr = currentUnit === 'cm' ? '' : ' cm'
  return text.replace(regex, (match) => {
    let convertedValue = convertTextValue(match, currentUnit);
    return `${convertedValue}${unitStr}`;  // 更新单位为当前单位（cm 或 in）
  });
}

// 单位转换函数
function convertTextValue(value, currentUnit) {

  // 计算转换后的值
  if (currentUnit === 'cm') {
    return cmToFeetInches(value);
  } else if (currentUnit === 'in') {
    return feetInchesToCm(value);
  }
  return value; // unknown unit 如果是相同单位，不做转换
}

function convertCellValue(value, currentUnit) {

  // 计算转换后的值
  if (currentUnit === 'cm') {
    return cmToFeetInches(value, true);
  } else if (currentUnit === 'in') {
    return feetInchesToCm(value);
  }
  return value; // unknown unit 如果是相同单位，不做转换
}

function normalizeCm(cmStr) {
  return Number(cmStr.replace(/cm/i, '').trim());
}

function normalizeFt(str) {
  const m = String(str).match(/(?:(\d+)'\s*)?(\d+(?:\.\d+)?)"/);
  if (!m) return null;
  const feet = parseInt(m[1] || "0", 10);
  const inches = parseFloat(m[2]);
  const totalInches = feet * 12 + inches;
  return Number(totalInches);
}

function cmToFeetInches(cmStr, toInches = false) {
  const cm = normalizeCm(cmStr);
  let totalInches = null;

  totalInches = parseFloat((cm / 2.54).toFixed(1));

  if (toInches) {
    return `${totalInches}"`;
  }

  const feet = Math.floor(totalInches / 12);
  const inches = parseFloat((totalInches % 12).toFixed(0));

  return `${feet}'${inches}"`;
}

function feetInchesToCm(inputStr) {
  const totalInches = normalizeFt(inputStr);

  if (!totalInches) {
    throw new Error("Invalid format. Use e.g., 5'10\"");
  }

  let cm = null;

  cm = parseFloat((totalInches * 2.54).toFixed(1));

  return cm;
}
